import { defineMessages } from 'react-intl';

export default defineMessages({
    modelYear: {
        "id": "twia.view.Model Year",
        "defaultMessage": "Model Year"
    },
    yearBuilt: {
        "id": "twia.view.Year Built",
        "defaultMessage": "Year Built"
    },
    documentsCount: {
        id: 'gateway.contacts.views.policy-contact-detail.Documents Count',
        defaultMessage: 'Documents {documentsCount}',
    },
})